"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FunctionsRounded2 = _interopRequireDefault(require("@material-ui/icons/FunctionsRounded"));

var _LockRounded2 = _interopRequireDefault(require("@material-ui/icons/LockRounded"));

var _ExitToAppRounded2 = _interopRequireDefault(require("@material-ui/icons/ExitToAppRounded"));

var _FormatListNumberedRounded2 = _interopRequireDefault(require("@material-ui/icons/FormatListNumberedRounded"));

var _PersonAddRounded2 = _interopRequireDefault(require("@material-ui/icons/PersonAddRounded"));

var _EventAvailableRounded2 = _interopRequireDefault(require("@material-ui/icons/EventAvailableRounded"));

var _PostAddRounded2 = _interopRequireDefault(require("@material-ui/icons/PostAddRounded"));

var _ExposurePlus1Rounded2 = _interopRequireDefault(require("@material-ui/icons/ExposurePlus1Rounded"));

var _StarRounded2 = _interopRequireDefault(require("@material-ui/icons/StarRounded"));

var _AccessTimeRounded2 = _interopRequireDefault(require("@material-ui/icons/AccessTimeRounded"));

var _AttachMoneyRounded2 = _interopRequireDefault(require("@material-ui/icons/AttachMoneyRounded"));

var _LinkRounded2 = _interopRequireDefault(require("@material-ui/icons/LinkRounded"));

var _EmailRounded2 = _interopRequireDefault(require("@material-ui/icons/EmailRounded"));

var _PhoneRounded2 = _interopRequireDefault(require("@material-ui/icons/PhoneRounded"));

var _DateRangeRounded2 = _interopRequireDefault(require("@material-ui/icons/DateRangeRounded"));

var _ArrowDropDownCircleRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownCircleRounded"));

var _TocRounded2 = _interopRequireDefault(require("@material-ui/icons/TocRounded"));

var _InsertDriveFileRounded2 = _interopRequireDefault(require("@material-ui/icons/InsertDriveFileRounded"));

var _FormatIndentIncreaseRounded2 = _interopRequireDefault(require("@material-ui/icons/FormatIndentIncreaseRounded"));

var _CheckBoxRounded2 = _interopRequireDefault(require("@material-ui/icons/CheckBoxRounded"));

var _SubjectRounded2 = _interopRequireDefault(require("@material-ui/icons/SubjectRounded"));

var _Looks3Rounded2 = _interopRequireDefault(require("@material-ui/icons/Looks3Rounded"));

var _TextFormatRounded2 = _interopRequireDefault(require("@material-ui/icons/TextFormatRounded"));

var _AddRounded2 = _interopRequireDefault(require("@material-ui/icons/AddRounded"));

var _react = _interopRequireDefault(require("react"));

var _Barcode = _interopRequireDefault(require("./icons/Barcode"));

var _FaPercetage = _interopRequireDefault(require("./icons/FaPercetage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  add: /*#__PURE__*/_react["default"].createElement(_AddRounded2["default"], {
    fontSize: "small"
  }),
  singleLineText: /*#__PURE__*/_react["default"].createElement(_TextFormatRounded2["default"], {
    fontSize: "small"
  }),
  number: /*#__PURE__*/_react["default"].createElement(_Looks3Rounded2["default"], {
    fontSize: "small"
  }),
  longText: /*#__PURE__*/_react["default"].createElement(_SubjectRounded2["default"], {
    fontSize: "small"
  }),
  checkBox: /*#__PURE__*/_react["default"].createElement(_CheckBoxRounded2["default"], {
    fontSize: "small"
  }),
  linkToRecord: /*#__PURE__*/_react["default"].createElement(_FormatIndentIncreaseRounded2["default"], {
    fontSize: "small"
  }),
  attachment: /*#__PURE__*/_react["default"].createElement(_InsertDriveFileRounded2["default"], {
    fontSize: "small"
  }),
  multiSelect: /*#__PURE__*/_react["default"].createElement(_TocRounded2["default"], {
    fontSize: "small"
  }),
  singleSelect: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownCircleRounded2["default"], {
    fontSize: "small"
  }),
  date: /*#__PURE__*/_react["default"].createElement(_DateRangeRounded2["default"], {
    fontSize: "small"
  }),
  phoneNumber: /*#__PURE__*/_react["default"].createElement(_PhoneRounded2["default"], {
    fontSize: "small"
  }),
  email: /*#__PURE__*/_react["default"].createElement(_EmailRounded2["default"], {
    fontSize: "small"
  }),
  url: /*#__PURE__*/_react["default"].createElement(_LinkRounded2["default"], {
    fontSize: "small"
  }),
  currency: /*#__PURE__*/_react["default"].createElement(_AttachMoneyRounded2["default"], {
    fontSize: "small"
  }),
  percent: /*#__PURE__*/_react["default"].createElement(_FaPercetage["default"], {
    fontSize: "small"
  }),
  duration: /*#__PURE__*/_react["default"].createElement(_AccessTimeRounded2["default"], {
    fontSize: "small"
  }),
  rating: /*#__PURE__*/_react["default"].createElement(_StarRounded2["default"], {
    fontSize: "small"
  }),
  count: /*#__PURE__*/_react["default"].createElement(_ExposurePlus1Rounded2["default"], {
    fontSize: "small"
  }),
  lookup: /*#__PURE__*/_react["default"].createElement(_PostAddRounded2["default"], {
    fontSize: "small"
  }),
  createdAt: /*#__PURE__*/_react["default"].createElement(_EventAvailableRounded2["default"], {
    fontSize: "small"
  }),
  updatedAt: /*#__PURE__*/_react["default"].createElement(_EventAvailableRounded2["default"], {
    fontSize: "small"
  }),
  createdBy: /*#__PURE__*/_react["default"].createElement(_PersonAddRounded2["default"], {
    fontSize: "small"
  }),
  updatedBy: /*#__PURE__*/_react["default"].createElement(_PersonAddRounded2["default"], {
    fontSize: "small"
  }),
  collaborator: /*#__PURE__*/_react["default"].createElement(_PersonAddRounded2["default"], {
    fontSize: "small"
  }),
  autoNumber: /*#__PURE__*/_react["default"].createElement(_FormatListNumberedRounded2["default"], {
    fontSize: "small"
  }),
  button: /*#__PURE__*/_react["default"].createElement(_ExitToAppRounded2["default"], {
    fontSize: "small"
  }),
  password: /*#__PURE__*/_react["default"].createElement(_LockRounded2["default"], {
    fontSize: "small"
  }),
  barcode: /*#__PURE__*/_react["default"].createElement(_Barcode["default"], {
    fontSize: "small"
  }),
  formula: /*#__PURE__*/_react["default"].createElement(_FunctionsRounded2["default"], {
    fontSize: "small"
  })
};
exports["default"] = _default;